import React from "react";

export function SignInRequired({
  eyebrow,
  title = "Enter your Sleeper username.",
  description = "Sign in with your username to use this feature.",
  onSignIn,
  testId = "sign-in-required",
  className = "",
}) {
  return (
    <div className={`brutal-card p-6 ${className}`} data-testid={testId}>
      {eyebrow ? <span className="label-eyebrow">{eyebrow}</span> : null}
      <h3 className="font-display font-black text-xl tracking-tighter mt-1">{title}</h3>
      <p className="text-sm text-[#52525B] mt-2 leading-relaxed">{description}</p>
      <button
        type="button"
        onClick={onSignIn}
        className="mt-5 bg-[#7C3AED] text-white border border-[#0A0A0A] px-4 py-3 text-xs uppercase tracking-widest font-semibold hover:bg-[#0A0A0A] transition-colors"
        data-testid="guest-sign-in"
      >
        Sign in with Sleeper
      </button>
    </div>
  );
}
